import React, { useEffect, useState } from 'react';

import { Modal, Text, Input, InputAddress } from 'v3/components';
import DOMPurify from 'dompurify';
import Space from 'v3/components/Space';
import { fetchByCityAndProvince } from 'utils/fetches';
import { useSnackbar } from 'v3/components/Snackbar';
import { StyledModalButton } from 'v3/pages/Policy/styles';
import { Col } from 'react-bootstrap';
import { RiskAreaSchema } from '../../../validators';
import { usePolicyRegister } from '../../context';

export function RiskAreaModal() {
  const {
    riskAreaModal,
    operations,
    setOperations,
    currentOpIndex,
    setCurrentOpIndex,
    currentPdIndex,
    setCurrentPdIndex,
    currentVehicleIndex,
    setCurrentVehicleIndex,
    currentRangeIndex,
    setCurrentRangeIndex,
  } = usePolicyRegister();

  const snackbar = useSnackbar();
  const [newRiskArea, setNewRiskArea] = useState({ city: {}, radius: null });
 const [errors, setErrors] = useState({});

  const cleanText = (val) =>
    DOMPurify.sanitize(val ?? '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();

  async function handleAdd() {
    const validation = await validate(newRiskArea, setErrors);

    if (!validation?.valid && newRiskArea?.city?.name && validation?.errors['city.id']) {
      snackbar.show(
        <Text color="dark">Cidade não cadastrada na base Cooperplace, solicite cadastro.</Text>,
        { type: 'error', showClose: true },
      );
      setErrors((old) => ({ 'city.id': old['city.id'] }));
      return;
    }
    if (!validation?.valid) {
      snackbar.show(<Text color="dark">Verifique campos obrigatórios.</Text>, {
        type: 'error',
        showClose: true,
      });
      return;
    }

    const newState = [...operations];
    newState[currentOpIndex].products[currentPdIndex].vehicles[currentVehicleIndex].ranges[
      currentRangeIndex
    ].riskAreas = [
      ...newState[currentOpIndex].products[currentPdIndex].vehicles[currentVehicleIndex].ranges[
        currentRangeIndex
      ].riskAreas,
      newRiskArea,
    ];
    setOperations(newState);
    setNewRiskArea({});
    setCurrentOpIndex(null);
    setCurrentPdIndex(null);
    setCurrentVehicleIndex(null);
    setCurrentRangeIndex(null);
    riskAreaModal.close();
  }

  function handleCloseModal() {
    setNewRiskArea({});
    setErrors({});
    setCurrentOpIndex(null);
    setCurrentPdIndex(null);
    setCurrentVehicleIndex(null);
    setCurrentRangeIndex(null);
    riskAreaModal.close();
  }

  async function validate(data, setErrors) {
    const errorList = {};
    try {
      await RiskAreaSchema.validate(data, { abortEarly: false });
      setErrors({ ...errorList });
      return { valid: true, errors: errorList };
    } catch (err) {
      if (err.inner) {
        err.inner.forEach((e) => {
          errorList[e.path] = e.message;
        });
        setErrors({ ...errorList });
        return { valid: false, errors: errorList };
      }
      setErrors({ ...errorList });
      return { valid: false, errors: errorList };
    }
  }

  return (
    <Modal
      size="lg"
      show={riskAreaModal.isOpen}
      handleClose={handleCloseModal}
      heading={
        <Text type="body" color="dark" weight="400">
          Inclusão de área de risco
        </Text>
      }
      body={
        <div>
          <Col>
            <InputAddress
              label="Município *"
              typesRestriction={['(cities)']}
              placeholder="Busque um município..."
              removeCountryRestriction
              onSelectedAddress={async (place) => {
                const cityName = cleanText(place?.city);
                const provinceName = cleanText(place?.province);

                const [city] = await fetchByCityAndProvince(cityName, provinceName);
                setNewRiskArea((old) => ({
                  ...old,
                  city: {
                    id: city?.id,
                    lat: place?.lat,
                    lng: place?.lng,
                    name: city?.name || cleanText(place?.name),
                  },
                }));
              }}
              error={errors['city.name'] || errors['city.id']}
            />
          </Col>

          <Input
            label="Raio (km) *"
            value={newRiskArea?.radius}
            onChange={(e) => {
              const val = cleanText(e?.target?.value);
              setNewRiskArea((old) => ({ ...old, radius: val }));
            }}
            error={errors?.radius}
          />

          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <Input
              label="Latitude *"
              disabled
              tooltip="Selecione um município sugerido para obter dados de latitude e longitude"
              value={newRiskArea?.city?.lat}
              error={errors['city.lat']}
            />
            <Input
              label="Longitude *"
              disabled
              tooltip="Selecione um município sugerido para obter dados de latitude e longitude"
              value={newRiskArea?.city?.lng}
              error={errors['city.lng']}
            />
          </div>
        </div>
      }
      footer={
        <Space>
          <StyledModalButton size="sm" onClick={handleAdd}>
            <Text>Adicionar</Text>
          </StyledModalButton>
        </Space>
      }
    />
  );
}
